import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    bottomItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      flex: 1,
      marginBottom: MIDDLE_MARGIN,
      '&:last-child': {
        marginBottom: 0,
      },
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        marginRight: LARGE_MARGIN,
        marginBottom: 0,
        '&:last-child': {
          marginRight: 0,
        },
      },
    },
    bottomItemImageWrapper: {
      width: 65,
      minWidth: 65,
      marginBottom: SMALL_MARGIN / 2,
      '& svg': {
        width: '100%',
      },
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
        marginRight: SMALL_MARGIN,
      },
    },
    bottomItemImg: {
      width: '100%',
    },
    bottomItemText: {
      fontSize: 18,
      lineHeight: 1.5,
      color: colorsPalette.white,
      maxWidth: 280,
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        textAlign: 'left',
      },
    },
  }),
);

export default useStyles;
